const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g><path d="M12 3.52A1.5 1.5 0 1 0 13.5 5 1.5 1.5 0 0 0 12 3.52Z" fill="currentColor"></path><path d="M17.54 0H6.46a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h11.08a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3Zm1 21a1 1 0 0 1-1 1H6.46a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h11.08a1 1 0 0 1 1 1Z" fill="currentColor"></path></g></svg>';
export {
  a as default
};
